import { Button } from '@sportik/ui/primitives/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@sportik/ui/primitives/empty';
import { BanIcon } from 'lucide-react';
import { EntryScreen } from '@/components/EntryScreen';
import { auth } from '@/services/auth';

type NotAllowedProps = {
  title: string;
  description: string;
};

/**
 * The API refused this account; trying again cannot help, signing out can.
 * Shown where the account enters, like the sign-in page.
 */
export function NotAllowed({ title, description }: NotAllowedProps) {
  return (
    <EntryScreen>
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <BanIcon />
          </EmptyMedia>
          <EmptyTitle>{title}</EmptyTitle>
          <EmptyDescription>{description}</EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Button variant="outline" onClick={() => void auth.signOut()}>
            Sign out
          </Button>
        </EmptyContent>
      </Empty>
    </EntryScreen>
  );
}
